export default __webpack_public_path__ + "static/media/choose-the-right-paver-color-driveway.196f1236.jpg";